<template>
  <v-menu
    content-class="predicted-financial-impact-info-tooltip-menu"
    open-on-hover
    :bottom="!top"
    :top="top"
    max-width="250px"
    offset-y
  >
    <template #activator="{ on, attrs }">
      <v-icon
        v-bind="attrs"
        :class="iconClass"
        :color="iconColor"
        :data-testid="dataTestid"
        :size="iconSize"
        v-on="on"
      >
        mdi-information-outline
      </v-icon>
    </template>
    <div class="px-3 py-2" :data-testid="`${dataTestid}-content`">
      <span class="text-body-2 white--text d-block">
        {{ text }}
      </span>
      <a
        class="caption predicted-financial-impact-info-tooltip-link"
        :href="helpCenterLink"
        rel="noopener noreferrer"
        target="_blank"
      >
        {{ $t('common.learn_more') }}
      </a>
    </div>
  </v-menu>
</template>

<script>
export default {
  name: 'PredictedFinancialImpactInfoTooltip',

  props: {
    text: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      default: 'grey lighten-1',
    },
    iconSize: {
      type: [String, Number],
      default: 16,
    },
    top: {
      type: Boolean,
      default: false,
    },
    iconClass: {
      type: String,
      default: '',
    },
    dataTestid: {
      type: String,
      default: 'predicted-financial-impact-info-tooltip',
    },
  },

  computed: {
    helpCenterLink() {
      return this.$t('rev.financial_potential_impact.help_center_article')
    },
  },
}
</script>
<style lang="scss">
.predicted-financial-impact-info-tooltip-link {
  color: $color-blue;
  text-decoration: none;
}
.v-menu__content.predicted-financial-impact-info-tooltip-menu {
  background-color: rgba(33, 33, 33, 0.9) !important;
  backdrop-filter: blur(2px);
  box-shadow: none;
}
</style>
